var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-md flex-center px-4 py-1",class:{
    'bg-level-h-light': _vm.status === 'Cancelled',
    'bg-level-l-light': _vm.status === 'Closed',
    'bg-primary-light': _vm.status === 'Opened',
  }},[_c('p',{staticClass:"text-sm tracking-wider font-semibold",class:{
      'text-level-h': _vm.status === 'Cancelled',
      'text-level-l': _vm.status === 'Closed',
      'text-primary': _vm.status === 'Opened',
      blink: _vm.status === 'Opened',
    }},[_vm._v(" "+_vm._s(_vm.status == "Cancelled" ? "Cancelled" : _vm.status == "Closed" ? "Completed" : "Running")+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }